import { render, staticRenderFns } from "./MoleculeContentThumbSliderBrochure.vue?vue&type=template&id=5c3c035e&"
import script from "./MoleculeContentThumbSliderBrochure.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentThumbSliderBrochure.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentThumbSliderBrochure.vue?vue&type=style&index=0&id=5c3c035e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports